

































































































































































































































import { defineComponent, ref, onBeforeMount } from '@vue/composition-api'
import { searchVendors } from '@/api/search'
import { IVendorItem } from '@/api/types-vendor'
import { deleteVendor } from '@/api/vendors'
import { VendorsModule } from '@/store/modules/vendors'
import { sortByNumber, sortByString } from '@/utils/sort'

interface FilterOption {
  property: string
  value: string | number
  checked: boolean
  label: string
}

interface Filter {
  property: string
  value: string | number
}

enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export default defineComponent({
  name: 'vendors2',
  setup() {
    const loading = ref(true)
    const tableData = ref(null)
    // const vendorItem = ref<IVendorItem>(null)

    const perPage = ref<number>(15)
    const perPageOptions = ref([
      {
        value: 15,
        label: 15
      },
      {
        value: 20,
        label: 20
      },
      {
        value: 40,
        label: 40
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ])
    const showFilters = ref(false)
    const pageNumber = ref(1)
    const keyword = ref<string>('')
    const sortDirection = ref<SortDirection>(null)
    const sortBy = ref<string>(null)
    const sortByDirectionOptions = ref([
      {
        value: null,
        label: ''
      },
      {
        value: SortDirection.ASC,
        label: 'Ascending'
      },
      {
        value: SortDirection.DESC,
        label: 'Descending'
      }
    ])
    const sortByOptions = ref([
      {
        value: null,
        label: ''
      },
      {
        value: 'LastName',
        label: 'Name'
      },
      {
        value: 'PostalCode',
        label: 'Zip Code'
      },
      {
        value: 'City',
        label: 'City'
      },
      {
        value: 'State',
        label: 'State'
      }
    ])

    const totalPages = ref<number>(0)
    const totalItems = ref<number>(0)
    const pageItems = ref<number>(0)

    const filterOptions = ref<Array<FilterOption>>([
      {
        property: 'FirstName',
        label: 'First Name',
        checked: false,
        value: null
      },
      {
        property: 'LastName',
        label: 'Last Name',
        checked: false,
        value: null
      },
      {
        property: 'City',
        label: 'City',
        checked: false,
        value: null
      },
      {
        property: 'State',
        label: 'State',
        checked: false,
        value: null
      },
      {
        property: 'PostalCode',
        label: 'Zip Code',
        checked: false,
        value: null
      }
    ])
    const filterBy = ref<Filter[]>(null)

    const defaultData = {
      perPage: 20,
      pageNumber: 1,
      filterBy: null,
      sort: null,
      sortBy: null
    }

    const data = ref({
      perPage,
      pageNumber,
      filterBy,
      sort: sortDirection,
      sortBy
    })

    const getVendorsTableData = async() => {
      filterOptions.value.forEach(f => { f.checked = false; f.value = null })
      data.value = defaultData
      VendorsModule.updateSearch(keyword.value)
      return fetchData(data.value)
      // return resetAll()
      // const response = await getVendors()
      // tableData.value = response.data.vendorCounts
    }

    const fetchData = async(_data) => {
      loading.value = true
      VendorsModule.updateSearch(keyword.value)

      const filters: Filter[] = []
      filterOptions.value.forEach(filterOption => {
        if (filterOption.checked && filterOption.value !== null) {
          filters.push({
            property: filterOption.property,
            value: filterOption.value
          })
        }
      })
      _data.filterBy = filters.length > 0 ? filters : null
      _data.sort = sortDirection
      _data.sortBy = sortBy
      _data.perPage = perPage
      const response = (await searchVendors(_data, keyword.value)).data

      pageNumber.value = response.pageNumber
      totalPages.value = response.totalPages
      perPage.value = parseInt(response.perPage)
      totalItems.value = response.totalItems
      pageItems.value = response.pageItems
      tableData.value = response.items
      loading.value = false
    }

    const updatePage = (page) => {
      data.value.pageNumber = page
      fetchData(data.value)
    }

    const resetAll = () => {
      filterOptions.value.forEach(f => { f.checked = false; f.value = null })
      data.value = defaultData
      keyword.value = null
      VendorsModule.updateSearch(keyword.value)
      fetchData(data.value)
    }

    const updateFilter = (filter) => {
      if (!filter.checked && filter.value != null) {
        filterBy.value = filterBy.value.filter(fil => fil.property !== filter.property)
        fetchData(data.value)
        return
      }

      if (filter.checked && filter.value != null) {
        fetchData(data.value)
      }
    }

    const handleDelete = async(vendorId: number) => {
      await deleteVendor(vendorId)
      resetAll()
    }

    const sortVendorId = (a: IVendorItem, b: IVendorItem): number => {
      return sortByNumber(a.vendorId, b.vendorId)
    }

    const sortName = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.displayName, b.displayName)
    }

    const sortAddress = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.address, b.address)
    }

    const sortCity = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.city, b.city)
    }

    const sortState = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.state, b.state)
    }

    const sortPostalCode = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.postalCode, b.postalCode)
    }

    const sortCompany = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.vendorCompanyName, b.vendorCompanyName)
    }

    const sortEmail = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.email, b.email)
    }

    const sortPhone = (a: IVendorItem, b: IVendorItem): number => {
      return sortByString(a.phone, b.phone)
    }

    onBeforeMount(async() => {
      keyword.value = await VendorsModule.getSearch()
      getVendorsTableData()
    })

    return {
      data,
      loading,
      tableData,
      keyword,
      totalPages,
      fetchData,
      updatePage,
      filterBy,
      filterOptions,
      totalItems,
      pageItems,
      perPage,
      perPageOptions,
      getVendorsTableData,
      resetAll,
      showFilters,
      sortBy,
      sortByDirectionOptions,
      sortDirection,
      sortByOptions,

      sortVendorId,
      sortName,
      sortAddress,
      sortCity,
      sortState,
      sortPostalCode,
      sortCompany,
      sortEmail,
      sortPhone,

      updateFilter,
      handleDelete
    }
  }
})
